import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { IconBrandZoom } from '@calendly/ui/components/glyphs/IconBrandZoom'
import { IconChevronDown } from '@calendly/ui/components/glyphs/IconChevronDown'
import { IconDotsVertical } from '@calendly/ui/components/glyphs/IconDotsVertical'
import { IconMapPin } from '@calendly/ui/components/glyphs/IconMapPin'
import { IconPhone } from '@calendly/ui/components/glyphs/IconPhone'
import { UiIcon } from '@calendly/ui/components/ui-icon'

import { getLabelForKind } from 'components/event_type_edit/location_v3/utils'

import { LocationOptionSections, LocationOptionsPanel } from './location_options_panel'
import { AllOptionsWrapper, allOptionsButtonCss, Container, LocationButtonsRow } from './styles'

const getLocationButtons = (shouldDisableOutbound) => [
  {
    kind: 'zoom_conference',
    icon: IconBrandZoom,
  },
  {
    kind: 'physical',
    icon: IconMapPin,
  },
  {
    kind: shouldDisableOutbound ? 'inbound_call' : 'outbound_call',
    icon: IconPhone,
  },
]

const LocationButton = ({ onClickAction, icon, kind }) => (
  <Button appearance="secondary-outline" size="medium" responsive={false} onClick={onClickAction}>
    <UiIcon icon={icon} size="small" title="" />
    {getLabelForKind(kind)}
  </Button>
)

const AllOptionsButton = ({ onSelect, availableKinds }) => {
  const [toggleAllOptionsDropdown, AllOptionsDropdown, isOpen] = useDropdown()

  return (
    <AllOptionsWrapper>
      <Button
        appearance="secondary-outline"
        size="medium"
        responsive={false}
        aria-expanded={isOpen}
        onClick={toggleAllOptionsDropdown}
        className={allOptionsButtonCss}
      >
        <UiIcon icon={IconDotsVertical} size="small" title="" />
        {I18n.t('publisher.event_type_editor_crud.meeting_details.location.all_label')}
        <UiIcon icon={IconChevronDown} size="small" title="" />
      </Button>
      <AllOptionsDropdown>
        <LocationOptionsPanel>
          <LocationOptionSections possibleKinds={availableKinds} onSelect={onSelect} />
        </LocationOptionsPanel>
      </AllOptionsDropdown>
    </AllOptionsWrapper>
  )
}

export const LocationSelectButtons = ({
  onChange,
  availableKinds,
  shouldDisableOutbound
}) => {
  const locationButtons = getLocationButtons(shouldDisableOutbound)
  const kindsFiltered = availableKinds
    .filter(({ type }) => type !== 'divider')
    .map(({ value }) => value)

  return (
    <LocationButtonsRow>
      <Container data-calendly-label="event-details-location">
        {locationButtons.map(({ kind, icon }) => (
          <LocationButton
            key={kind}
            icon={icon}
            kind={kind}
            onClickAction={() => onChange(kind)}
          />
        ))}
        <AllOptionsButton
          onSelect={onChange}
          availableKinds={kindsFiltered}
        />
      </Container>
    </LocationButtonsRow>
  )
}
